module.exports = __webpack_public_path__ + "img/logo-bd2.901e9f6a.png";